import { useRoute, useRouter, computed, ref } from '@nuxtjs/composition-api';
import getStringInSnakeCase from '~/composables/useStringToSnakeCase';

const useFilter = (params) => {
  const filterParams = {
    filter: true,
    ...params,
  };

  const router = useRouter();
  const route = useRoute();
  const PAGE_MAX_PRODUCTS = 12;
  const selectedFilters = ref({});
  const historyFilters = ref(null);

  const getQueriesFromURL = computed(() => route.value.query);

  const clearFilter = () => {
    selectedFilters.value = {};
  };

  const updateSelectedFilters = (payload) => {
    selectedFilters.value = {
      ...selectedFilters.value,
      [getStringInSnakeCase(payload.caption)]: payload.value,
    };
  };

  const deleteEmptyKeyFromObject = (object) => {
    const currentObject = { ...object };
    Object.keys(currentObject).forEach((key) => {
      if (
        currentObject[key] === null ||
        currentObject[key] === undefined ||
        currentObject[key].length === 0
      ) {
        delete currentObject[key];
      }
    });
    return currentObject;
  };

  const removeSelectedFilterById = (idFrom) => {
    let newObject = { ...selectedFilters.value };
    Object.keys(selectedFilters.value).forEach((key) => {
      newObject = {
        ...newObject,
        [key]: selectedFilters.value[key].filter((id) => id !== idFrom),
      };
    });
    selectedFilters.value = { ...newObject };
  };

  const initFilter = () => {
    if (!filterParams.filter) return;

    if (Object.keys(getQueriesFromURL.value).length !== 0) {
      const keys = Object.keys(getQueriesFromURL.value);
      keys.forEach((key) => {
        if (key.toLowerCase() !== 'page')
          selectedFilters.value = {
            ...selectedFilters.value,
            [key]: getQueriesFromURL.value[key]
              .split(',')
              .map((query) => +query),
          };
      });
    }
  };

  const addToFilterHistory = () => {
    historyFilters.value = selectedFilters.value;
  };

  const addFilterHistoryToSelectedFilters = () => {
    selectedFilters.value = historyFilters.value;
    historyFilters.value = null;
  };

  const filterQueryParamsForRoute = computed(() => {
    const arrayParams = ref({});
    Object.keys(selectedFilters.value).forEach((key) => {
      arrayParams.value = {
        ...arrayParams.value,
        ...(selectedFilters.value[key] && {
          [key]: selectedFilters.value[key],
        }),
      };
    });
    return arrayParams.value;
  });

  const addQueryToRoute = (page = 1) => {
    selectedFilters.value = deleteEmptyKeyFromObject(selectedFilters.value);
    const queryRouteParams = {
      ...(page !== 1 && { page }),
      ...(Object.keys(filterQueryParamsForRoute.value).length !== 0 &&
        filterQueryParamsForRoute.value),
    };

    router.push({
      query: queryRouteParams,
    });
  };

  // eslint-disable-next-line no-unused-vars
  const selectedFilterIds = computed(() => {
    const arrayIds = ref([]);
    Object.keys(selectedFilters.value).forEach((key) => {
      arrayIds.value = arrayIds.value.concat(selectedFilters.value[key]);
    });
    return arrayIds.value;
  });

  const getQueryParams = computed(() => ({
    ...filterQueryParamsForRoute.value,
    page: +getQueriesFromURL.value.page || 1,
    limit: PAGE_MAX_PRODUCTS,
  }));

  initFilter();

  return {
    getQueriesFromURL,
    selectedFilters,
    PAGE_MAX_PRODUCTS,
    getQueryParams,
    clearFilter,
    removeSelectedFilterById,
    updateSelectedFilters,
    addQueryToRoute,
    addToFilterHistory,
    addFilterHistoryToSelectedFilters,
  };
};

export default useFilter;
